import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { CAPIConfigurations } from '../../Integrations/NativeIntegrations/components/FacebookAdsIntegrations/CAPIConfigurations';
import {
  RestoreMetaAnalytics,
  RestoreMetaAnalyticsEmptyState,
} from '../../Analytics/XRayAnalytics/RestoreMetaAnalytics/RestoreMetaAnalytics';
import css from './RestoreAnalaytics.module.css';
import { Button } from '@mm/components';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { ButtonColor } from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { useHistory } from 'react-router-dom';
import { BotBuilderRoutes } from '../../../../../../routes/bot-builder-routes';

export const RestoreAnalytics = ({ className }: { className?: string }) => {
  const containerClassName = classNames(className, css.container);
  const chatbotId = useSelector(activeChatbotIdSelector);

  const history = useHistory();

  return (
    <div className={containerClassName}>
      <div className={css.header}>
        <span className={css.title}>Restore Analytics</span>

        <Button
          css={{ container: css.headerBtn }}
          color={ButtonColor.secondaryBlue}
          onClick={() => {
            history.push(BotBuilderRoutes.restore.getLink({ chatbotId }));
          }}
        >
          Go to Restore tool
        </Button>
      </div>

      <RestoreMetaAnalytics extended />

      <CAPIConfigurations
        className={css.capiAnalytics}
        styles={{
          table: css.table,
          tableHeader: css.tableHeader,
          tableRows: css.tableRows,
        }}
        withHeader={false}
        gridColumns="40% 60%"
        remappedColumns={{
          event: (
            <div>
              Super-CAPI Event Matching{' '}
              <span className={css.note}>(All time)</span>
            </div>
          ),
          total_sent: 'Total Events Sent',
        }}
        emptyStateComponent={
          <div
            className={classNames(
              css.table,
              'integrations-grid',
              css.emptyTable,
            )}
          >
            <div className={classNames(css.tableHeader, css.emptyHeader)}>
              <span>Super-CAPI Event Matching</span>
              <span>Total Events Sent</span>
            </div>
            <RestoreMetaAnalyticsEmptyState button="Set up Super-CAPI" />
          </div>
        }
      />
    </div>
  );
};
